module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xl": "",
      "mt-5": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md10": "",
      "lg7": ""
    }
  }, [_c('v-form', {
    ref: "kycForm",
    model: {
      value: (_vm.kycFormValid),
      callback: function($$v) {
        _vm.kycFormValid = $$v
      },
      expression: "kycFormValid"
    }
  }, [_c('v-card', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_c('p', {
    staticClass: "mt-4 font-20 fw-400"
  }, [_vm._v(_vm._s(_vm.$t('kyc.identity')))]), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": _vm.$t('kyc.identity'),
      "items": _vm.identitySelect,
      "rules": _vm.identityRules,
      "item-text": "label",
      "item-value": "value",
      "required": ""
    },
    model: {
      value: (_vm.kycForm.identity),
      callback: function($$v) {
        _vm.$set(_vm.kycForm, "identity", $$v)
      },
      expression: "kycForm.identity"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "mt-4 font-20 fw-400"
  }, [_vm._v(_vm._s(_vm.$t('kyc.documentIssuingCountry')))]), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": _vm.$t('kyc.country'),
      "items": _vm.countrySelect,
      "rules": _vm.countryRules,
      "item-text": "label",
      "item-value": "value",
      "required": ""
    },
    model: {
      value: (_vm.kycForm.country),
      callback: function($$v) {
        _vm.$set(_vm.kycForm, "country", $$v)
      },
      expression: "kycForm.country"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "mt-4 font-20 fw-400"
  }, [_vm._v(_vm._s(_vm.$t('kyc.proofOfPermanentAddress')))]), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": _vm.$t('kyc.proofOfPermanentAddress'),
      "items": _vm.proofOfPermanentAddressSelect,
      "rules": _vm.proofOfPermanentAddressRules,
      "item-text": "label",
      "item-value": "value",
      "required": ""
    },
    model: {
      value: (_vm.kycForm.proofOfPermanentAddress),
      callback: function($$v) {
        _vm.$set(_vm.kycForm, "proofOfPermanentAddress", $$v)
      },
      expression: "kycForm.proofOfPermanentAddress"
    }
  })], 1)]), _vm._v(" "), _c('v-card', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_c('p', {
    staticClass: "mt-4 font-20 fw-400"
  }, [_vm._v(_vm._s(_vm.$t('kyc.basicInformation')))]), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('kyc.username'),
      "readonly": "",
      "disabled": ""
    },
    model: {
      value: (_vm.user.userName),
      callback: function($$v) {
        _vm.$set(_vm.user, "userName", $$v)
      },
      expression: "user.userName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Email",
      "readonly": "",
      "disabled": ""
    },
    model: {
      value: (_vm.user.regEmail),
      callback: function($$v) {
        _vm.$set(_vm.user, "regEmail", $$v)
      },
      expression: "user.regEmail"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "rules": _vm.firstNameRules,
      "label": _vm.$t('kyc.firstName'),
      "required": ""
    },
    model: {
      value: (_vm.kycForm.firstName),
      callback: function($$v) {
        _vm.$set(_vm.kycForm, "firstName", $$v)
      },
      expression: "kycForm.firstName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('kyc.middleName')
    },
    model: {
      value: (_vm.kycForm.middleName),
      callback: function($$v) {
        _vm.$set(_vm.kycForm, "middleName", $$v)
      },
      expression: "kycForm.middleName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "rules": _vm.lastNameRules,
      "label": _vm.$t('kyc.lastName'),
      "required": ""
    },
    model: {
      value: (_vm.kycForm.lastName),
      callback: function($$v) {
        _vm.$set(_vm.kycForm, "lastName", $$v)
      },
      expression: "kycForm.lastName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "rules": _vm.numberRules,
      "label": _vm.$t('kyc.documentNumber'),
      "required": ""
    },
    model: {
      value: (_vm.kycForm.number),
      callback: function($$v) {
        _vm.$set(_vm.kycForm, "number", $$v)
      },
      expression: "kycForm.number"
    }
  }), _vm._v(" "), _c('v-dialog', {
    ref: "birthdayDialog",
    attrs: {
      "lazy": "",
      "full-width": "",
      "width": "290px"
    },
    model: {
      value: (_vm.birthdayModal),
      callback: function($$v) {
        _vm.birthdayModal = $$v
      },
      expression: "birthdayModal"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "rules": _vm.birthdayRules,
      "label": _vm.$t('kyc.birthday'),
      "readonly": "",
      "clearable": "",
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.kycForm.birthday),
      callback: function($$v) {
        _vm.$set(_vm.kycForm, "birthday", $$v)
      },
      expression: "kycForm.birthday"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "header-color": "primary",
      "color": "primary",
      "max": new Date().toISOString().substr(0, 10)
    },
    on: {
      "input": function($event) {
        _vm.birthdayModal = false
      }
    },
    model: {
      value: (_vm.birthdayFormatted),
      callback: function($$v) {
        _vm.birthdayFormatted = $$v
      },
      expression: "birthdayFormatted"
    }
  })], 1), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": _vm.$t('kyc.gender.gender'),
      "items": _vm.genderSelect,
      "item-text": "label",
      "item-value": "value",
      "required": ""
    },
    model: {
      value: (_vm.kycForm.gender),
      callback: function($$v) {
        _vm.$set(_vm.kycForm, "gender", $$v)
      },
      expression: "kycForm.gender"
    }
  })], 1)], 1)]), _vm._v(" "), _c('v-card', {
    staticClass: "mt-4"
  }, [_c('v-layout', {
    staticClass: "pa-3",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('p', {
    staticClass: "mt-4 font-20 fw-400"
  }, [_vm._v(_vm._s(_vm.$t('kyc.documentFront')))])]), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.documentImageFrontUrl == null),
      expression: "documentImageFrontUrl == null"
    }],
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('Upload', {
    staticClass: "black--text",
    attrs: {
      "type": "drag",
      "enctype": "multipart/form-data",
      "name": "upfile",
      "action": _vm.uploadUrl,
      "headers": _vm.headers,
      "with-credentials": true,
      "before-upload": _vm.documentImageFrontBeforeUpload
    }
  }, [_c('Icon', {
    staticClass: "primary--text",
    attrs: {
      "type": "ios-cloud-upload",
      "size": "50"
    }
  }), _vm._v(" "), (_vm.documentImageFrontFile != null) ? _c('p', [_vm._v(_vm._s(_vm.$t("uploadMaterial.uploadFile")) + ": " + _vm._s(_vm.documentImageFrontFile.name))]) : _c('p', [_vm._v(_vm._s(_vm.$t("uploadMaterial.uploadHint")))])], 1), _vm._v(" "), _c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowDocumentImageFrontUploading),
      expression: "isShowDocumentImageFrontUploading"
    }],
    attrs: {
      "color": "primary",
      "indeterminate": true
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.documentImageFrontUrl != null),
      expression: "documentImageFrontUrl != null"
    }],
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.documentImageFrontUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('v-btn', {
    staticClass: "right primary--text mt-3",
    attrs: {
      "outline": ""
    },
    on: {
      "click": _vm.clearDocumentImageFrontFile
    }
  }, [_vm._v("\n\t\t\t\t                            " + _vm._s(_vm.$t("common.clear")) + "\n\t\t\t\t                        ")])], 1)])], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mt-4"
  }, [_c('v-layout', {
    staticClass: "pa-3",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('p', {
    staticClass: "mt-4 font-20 fw-400"
  }, [_vm._v(_vm._s(_vm.$t('kyc.documentBack')))])]), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.documentImageBackUrl == null),
      expression: "documentImageBackUrl == null"
    }],
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('Upload', {
    staticClass: "black--text",
    attrs: {
      "type": "drag",
      "enctype": "multipart/form-data",
      "name": "upfile",
      "action": _vm.uploadUrl,
      "headers": _vm.headers,
      "with-credentials": true,
      "before-upload": _vm.documentImageBackBeforeUpload
    }
  }, [_c('Icon', {
    staticClass: "primary--text",
    attrs: {
      "type": "ios-cloud-upload",
      "size": "50"
    }
  }), _vm._v(" "), (_vm.documentImageBackFile != null) ? _c('p', [_vm._v(_vm._s(_vm.$t("uploadMaterial.uploadFile")) + ": " + _vm._s(_vm.documentImageBackFile.name))]) : _c('p', [_vm._v(_vm._s(_vm.$t("uploadMaterial.uploadHint")))])], 1), _vm._v(" "), _c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowDocumentImageBackUploading),
      expression: "isShowDocumentImageBackUploading"
    }],
    attrs: {
      "color": "primary",
      "indeterminate": true
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.documentImageBackUrl != null),
      expression: "documentImageBackUrl != null"
    }],
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.documentImageBackUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('v-btn', {
    staticClass: "right primary--text mt-3",
    attrs: {
      "outline": ""
    },
    on: {
      "click": _vm.clearDocumentImageBackFile
    }
  }, [_vm._v("\n\t\t\t\t                            " + _vm._s(_vm.$t("common.clear")) + "\n\t\t\t\t                        ")])], 1)])], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mt-4"
  }, [_c('v-layout', {
    staticClass: "pa-3",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('p', {
    staticClass: "mt-4 font-20 fw-400"
  }, [_vm._v(_vm._s(_vm.$t('kyc.proofOfBill')))])]), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.proofImageUrl == null),
      expression: "proofImageUrl == null"
    }],
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('Upload', {
    staticClass: "black--text",
    attrs: {
      "type": "drag",
      "enctype": "multipart/form-data",
      "name": "upfile",
      "action": _vm.uploadUrl,
      "headers": _vm.headers,
      "with-credentials": true,
      "before-upload": _vm.proofImageBeforeUpload
    }
  }, [_c('Icon', {
    staticClass: "primary--text",
    attrs: {
      "type": "ios-cloud-upload",
      "size": "50"
    }
  }), _vm._v(" "), (_vm.proofImageFile != null) ? _c('p', [_vm._v(_vm._s(_vm.$t("uploadMaterial.uploadFile")) + ": " + _vm._s(_vm.proofImageFile.name))]) : _c('p', [_vm._v(_vm._s(_vm.$t("uploadMaterial.uploadHint")))])], 1), _vm._v(" "), _c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowProofImageUploading),
      expression: "isShowProofImageUploading"
    }],
    attrs: {
      "color": "primary",
      "indeterminate": true
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.proofImageUrl != null),
      expression: "proofImageUrl != null"
    }],
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.proofImageUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('v-btn', {
    staticClass: "right primary--text mt-3",
    attrs: {
      "outline": ""
    },
    on: {
      "click": _vm.clearProofImageFile
    }
  }, [_vm._v("\n\t\t\t\t                            " + _vm._s(_vm.$t("common.clear")) + "\n\t\t\t\t                        ")])], 1)])], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_c('p', {
    staticClass: "mt-4 font-20 fw-400"
  }, [_vm._v(_vm._s(_vm.$t('kyc.selfieWithPhotoIDAndNote')))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg6": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('img', {
    attrs: {
      "src": "https://images.iob.community/SIP-test/material/KYC/resource/selfie-example.jpg"
    }
  })])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "lg6": ""
    }
  }, [_c('p', {
    staticClass: "font-14 fw-400"
  }, [_vm._v(_vm._s(_vm.$t('kyc.selfieMessage')))]), _vm._v(" "), _c('ul', {
    staticClass: "font-14 fw-400"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('kyc.selfieList1')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('kyc.selfieList2')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('kyc.selfieList3')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('kyc.selfieList4')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('kyc.selfieList5')))])])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selfieImageUrl == null),
      expression: "selfieImageUrl == null"
    }],
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('Upload', {
    staticClass: "black--text",
    attrs: {
      "type": "drag",
      "enctype": "multipart/form-data",
      "name": "upfile",
      "action": _vm.uploadUrl,
      "headers": _vm.headers,
      "with-credentials": true,
      "before-upload": _vm.selfieImageBeforeUpload
    }
  }, [_c('Icon', {
    staticClass: "primary--text",
    attrs: {
      "type": "ios-cloud-upload",
      "size": "50"
    }
  }), _vm._v(" "), (_vm.selfieImageFile != null) ? _c('p', [_vm._v(_vm._s(_vm.$t("uploadMaterial.uploadFile")) + ": " + _vm._s(_vm.selfieImageFile.name))]) : _c('p', [_vm._v(_vm._s(_vm.$t("uploadMaterial.uploadHint")))])], 1), _vm._v(" "), _c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowSelfieImageUploading),
      expression: "isShowSelfieImageUploading"
    }],
    attrs: {
      "color": "primary",
      "indeterminate": true
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selfieImageUrl != null),
      expression: "selfieImageUrl != null"
    }],
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.selfieImageUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('v-btn', {
    staticClass: "right primary--text mt-3",
    attrs: {
      "outline": ""
    },
    on: {
      "click": _vm.clearSelfieImageFile
    }
  }, [_vm._v("\n\t\t\t\t\t                            " + _vm._s(_vm.$t("common.clear")) + "\n\t\t\t\t\t                        ")])], 1)])], 1)], 1)]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary--text right mt-5 mb-5",
    attrs: {
      "outline": "",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.submitUserKycHandle
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("common.submit")) + "\n                        ")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-378eeb68"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/UserKyc.vue
// module id = 431
// module chunks = 0